import React, { useState } from "react";
import RatingSelector from "./RatingSelector";
import FeedbackThankYou from "./FeedbackThankYou";
import FeedbackGoogleCTA from "./FeedbackGoogleCTA";
import { RatingType } from "./feedback.types";
import { useEffect } from "react";
import "./feedback.css";

interface Props {
  bookingId: string;
  isOpen: boolean;
  onClose: () => void;
}

const FeedbackModal: React.FC<Props> = ({
  bookingId,
  isOpen,
  onClose,
}) => {
  const [rating, setRating] = useState<RatingType | null>(null);
  const [comment, setComment] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showGoogleCTA, setShowGoogleCTA] = useState(false);

  const GOOGLE_REVIEW_URL = "https://www.google.com/maps/place/Co-work+@+level+3/@12.9265284,77.5146917,871m/data=!3m1!1e3!4m16!1m7!3m6!1s0x3bae3f8a3bc066bb:0x27efee28f08bcd78!2sCo-work+@+level+3!8m2!3d12.9265284!4d77.5146917!16s%2Fg%2F11mrn750x0!3m7!1s0x3bae3f8a3bc066bb:0x27efee28f08bcd78!8m2!3d12.9265284!4d77.5146917!9m1!1b1!16s%2Fg%2F11mrn750x0?hl=en&entry=ttu&g_ep=EgoyMDI2MDIxOC4wIKXMDSoASAFQAw%3D%3D";

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) {
      // Reset all state when modal closes
      setRating(null);
      setComment("");
      setSubmitted(false);
      setLoading(false);
      setShowGoogleCTA(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async () => {
  if (!rating) return;

  try {
    setLoading(true);

    await fetch("/api/feedback", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        bookingId,
        rating,
        comment,
      }),
    });

    if (rating === "love") {
      window.open(GOOGLE_REVIEW_URL, "_blank");
    }
    
    onClose();

  } catch (err) {
    console.error("Feedback error:", err);
  } finally {
    setLoading(false);
  }
};

return (
  <div
    className="feedback-overlay"
    onClick={onClose}
  >
    <div
      className="feedback-card"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-header">
        <h2>Rate your experience</h2>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
      </div>

      <RatingSelector
        selected={rating}
        onSelect={setRating}
      />

      <textarea
        placeholder="Tell us more (optional)"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        className="feedback-textarea"
      />

      <button
        className="submit-btn"
        disabled={!rating || loading}
        onClick={handleSubmit}
      >
        {loading ? "Submitting..." : rating === "love" ? "Leave a Google Review" : "Submit your feedback"}
      </button>
    </div>
  </div>
);
};

export default FeedbackModal;